export const state = {
  activeFilter: 'Muscles',
  selectedCategory: null,
  currentExerciseId: null,
  currentPage: 1,
  totalPages: 1,
};

export const PAGINATION_VISIBLE_PAGES = 5;